import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useLanguage } from '../LanguageContext';

export default function Gallery() {
  const { language } = useLanguage();

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#f9f9f9',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '40px 20px',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: '20px',
          color: '#212121ff',
        }}
      >
        {language === 'en' ? 'Conference Highlights' : 'Konferencia összefoglaló'}
      </Typography>

      {/* Photo Gallery Link */}
      <Box sx={{ textAlign: 'center', marginBottom: '40px' }}>
        <Link
          href="https://univpecs.com/galeria/20250509_kpvk_jatek_es_tarsadalom_nemzetkozi_konferencia_2025"
          target="_blank"
          underline="hover"
          sx={{ fontSize: '18px', color: '#cc0000', fontWeight: 'medium' }}
        >
          {language === 'en' ? '📷 View the Photo Gallery here' : '📷 Képgaléria megtekintése itt'}
        </Link>
      </Box>

      {/* Video section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          gap: 4,
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{
            flex: 1,
            minWidth: '300px',
            maxWidth: '560px',
            aspectRatio: '16 / 9',
          }}
        >
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/Ka4xxo1xea0?start=1181"
            title="YouTube video 1"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>

        <Box
          sx={{
            flex: 1,
            minWidth: '300px',
            maxWidth: '560px',
            aspectRatio: '16 / 9',
          }}
        >
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/cgiGWaaBA4k"
            title="YouTube video 2"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      </Box>
    </Box>
  );
}
